/**
 * @description  Widget States
 */
export default Object.freeze({
  INIT: 'init',
  NONE: 'hidden',
  HIDDEN: 'hidden',
  TEASER: 'teaser',
  FROZEN: 'frozen',
  FULL_FRAME: 'full',
  FULLFRAME: 'full',
  CLOSED: 'closed',
})
